// src/main.js
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import store from './store';
import router from './routes';
import { initKeycloak } from './keycloak';

const i18n = createI18n({ locale: 'es-AR', fallbackLocale: 'en' });

async function bootstrap() {
  // decide si la ruta inicial es pública o privada
  const isPublic = (path) => /^\/qr\/[^/]+$/.test(path) || path.startsWith('/404');
  const loginRequired = !isPublic(window.location.pathname);

  await initKeycloak({ loginRequired }); // fuerza login solo en privadas
  loadFonts();

  const app = createApp(App);
  app.use(vuetify).use(store).use(router).use(i18n)
    .mount('#app');
}
bootstrap();
